import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';

interface IProps {
  children: React.ReactNode;
  /** Adds padding */
  gutter?: boolean;
  hidden?: boolean;
  flexContainer?: boolean;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
  style?: React.CSSProperties;
}

const styles = (theme: Theme) => ({
  gutter: {
    padding: theme.spacing(1),
  },
  hidden: {
    display: 'none',
  },
  flexContainer: {
    flex: 1,
  },
});

/**
 * Kontroll för att gruppera flera komponenter till en komponent, kan lägga till layout
 *
 * För att gruppera komponenter utan att lägga till layout så kan React.Fragment användas istället
 */
export const EDView: React.FC<
  React.PropsWithChildren<IProps & React.RefAttributes<HTMLDivElement>>
> = forwardRef((props, ref) => {
  const classes = withStyles.getClasses(props);
  return (
    <div
      ref={ref}
      style={props.style}
      className={classNames(
        props.className,
        {
          [classes.gutter]: props.gutter,
        },
        { [classes.hidden]: props.hidden },
        { [classes.flexContainer]: props.flexContainer }
      )}
    >
      {props.children}
    </div>
  );
});

export default withStyles(EDView, styles);
